import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { initGA, logPageView, updateConsent } from "@/utils/analytics";
import { cn } from "@/lib/utils";

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Initialize GA with default denied consent
    initGA();

    const consent = localStorage.getItem("cookie_consent");

    if (consent === "granted") {
      updateConsent(true);
    } else if (!consent) {
      setIsVisible(true);
    }
  }, []);

  // Track page views when location changes
  useEffect(() => {
    // GA4 handles page views automatically, but we can force log if needed
    // or rely on enhanced measurement. Since we are using react-ga4,
    // manual logging is often safer for SPAs.
    logPageView(location.pathname);
  }, [location]);

  const handleAccept = () => {
    localStorage.setItem("cookie_consent", "granted");
    updateConsent(true);
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem("cookie_consent", "denied");
    updateConsent(false);
    setIsVisible(false);
  };
  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 z-50 animate-in slide-in-from-bottom-full duration-500">
      <Card className="max-w-4xl mx-auto p-6 shadow-lg border-primary/20 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="space-y-2 text-center md:text-left">
            <h3 className="text-lg font-semibold">We value your privacy</h3>
            <p className="text-sm text-muted-foreground max-w-2xl">
              We use cookies to enhance your experience, analyze site traffic,
              and personalize content. By clicking "Accept", you agree to our
              use of cookies.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 min-w-fit">
            <Button
              variant="outline"
              onClick={handleDecline}
              className="w-full sm:w-auto"
            >
              Decline
            </Button>
            <Button onClick={handleAccept} className="w-full sm:w-auto">
              Accept
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
